import axios from "axios";
import { useMutation } from "@tanstack/react-query";

export const useSubmitContactFormWithMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (message: string) => void;
  onError?: (error: unknown) => void;
}) => {
  return useMutation({
    mutationFn: async ({
      first_name,
      last_name,
      company,
      email,
      message,
      token,
    }: {
      first_name: string;
      last_name: string;
      company: string;
      email: string;
      message: string;
      token: string;
    }) => {
      try {
        const response = await axios({
          method: "POST",
          url: `${process.env.NEXT_PUBLIC_BASE_URL}/api/communication/contact`,
          data: {
            first_name: first_name,
            last_name: last_name,
            company: company,
            email: email,
            message: message,
            token: token,
          },
        });
        return response;
      } catch (err) {
        console.log("errr--<>", err);
        throw err;
      }
    },
    onSuccess: (axiosResponse) => {
      console.log(axiosResponse);
      onSuccess?.(axiosResponse?.data?.message);
    },
    onError: (error) => {
      console.log("error --<>", error);
      onError?.(error);
    },
  });
};
